import script from "./video-miniature-player.vue?vue&type=script&setup=true&lang=js"
export * from "./video-miniature-player.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__